function cov_k76iajxz9() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Chat.tsx";
  var hash = "c9e5e505e052acf482adad7eecf3d699f30b204c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Chat.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c9e5e505e052acf482adad7eecf3d699f30b204c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k76iajxz9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_k76iajxz9();
var Icon = (cov_k76iajxz9().s[0]++, {
  name: 'chat',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M6.03845 17.5L4.03655 19.5019C3.75193 19.7865 3.42469 19.8509 3.05483 19.6951C2.68494 19.5394 2.5 19.2589 2.5 18.8538V4.30773C2.5 3.8026 2.675 3.37503 3.025 3.02503C3.375 2.67503 3.80257 2.50003 4.3077 2.50003H19.6923C20.1974 2.50003 20.625 2.67503 20.975 3.02503C21.325 3.37503 21.5 3.8026 21.5 4.30773V15.6923C21.5 16.1974 21.325 16.625 20.975 16.975C20.625 17.325 20.1974 17.5 19.6923 17.5H6.03845ZM4.69233 16H19.6923C19.7692 16 19.8397 15.968 19.9038 15.9039C19.9679 15.8397 20 15.7692 20 15.6923V4.30773C20 4.2308 19.9679 4.16027 19.9038 4.09616C19.8397 4.03206 19.7692 4.00001 19.6923 4.00001H4.3077C4.23077 4.00001 4.16024 4.03206 4.09613 4.09616C4.03202 4.16027 3.99998 4.2308 3.99998 4.30773V16.6924L4.69233 16Z\" fill=\"currentColor\"/>"
});
export default Icon;